import type {
  Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../../util/invalidateQuery';
import type {
  KaminoInterestedPartyCreateMutation,
  KaminoInterestedPartyDeleteMutation,
  KaminoInterestedPartyReplaceMutation,
  KaminoInterestedPartyUpdateMutation,
} from '../../../generated/graphql';

function invalidateKaminoInterestedPartyMutationCache(cache: Cache) {
  invalidateQuery('entity', cache);
}

const interestedPartyMutations: UpdatesConfig['Mutation'] = {
  kaminoInterestedPartyCreate: (data: KaminoInterestedPartyCreateMutation, __: Variables, cache: Cache) => {
    if (data.kaminoInterestedPartyCreate) {
      invalidateKaminoInterestedPartyMutationCache(cache);
    }
  },

  kaminoInterestedPartyReplace: (data: KaminoInterestedPartyReplaceMutation, __: Variables, cache: Cache) => {
    if (data.kaminoInterestedPartyReplace) {
      invalidateKaminoInterestedPartyMutationCache(cache);
    }
  },

  kaminoInterestedPartyUpdate: (data: KaminoInterestedPartyUpdateMutation, __: Variables, cache: Cache) => {
    if (data.kaminoInterestedPartyUpdate) {
      invalidateKaminoInterestedPartyMutationCache(cache);
    }
  },

  kaminoInterestedPartyDelete: (data: KaminoInterestedPartyDeleteMutation, __: Variables, cache: Cache) => {
    if (data.kaminoInterestedPartyDelete) {
      invalidateKaminoInterestedPartyMutationCache(cache);
    }
  },
};

export default interestedPartyMutations;
